import { axiosConfigBuilder } from '..';

export class FolderService {
  /**
   * @typedef {Object} Folder
   * @property {number} [id=0]
   * @property {string} [name=All Marketing Mix Models]
   * @property {string} [folder_name] // Why do we have two different name entries when they are the same??
   * @property {Folder[]} [children]
   * @property {string} [company]
   * @property {string} [last_modified]
   * @property {number} [parentId]
   * @property {string} [type]
   * @property {boolean} [favourite]
   * @property {boolean} [isFolder=true]
   */


  /**
   *
   * @param {string} token - User authentication token.
   * @param {Object} folderDetails - Information required to create folder. 
   * @param {string} folderDetails.folderName - Folder name.
   * @param {Folder} folderDetails.currentParentFolder - Parent folder to attach to.
   * @returns {Object} - data confirming whether request was succesful.
   */
  async createNewFolder(token, folderDetails) {
    const folderCreationResponse = await axiosConfigBuilder(token).post(
      '/add_new_folder',
      folderDetails
    );
    return folderCreationResponse.data;
  }

  /**
   * 
   * @param {string} token - User authentication token.
   * @param {Object} removeFolderDetails - Information required to remove folder.
   * @param {Folder[]} removeFolderDetails.foldersToDelete - Folders requested for deletion.
   * @param {string} removeFolderDetails.countryCode - User country code.
   * @param {Object} removeFolderDetails.kwargs - KWArgs used in post requests, to know if the IDs are persistent or not.
   * @returns {Object} - data confirming whether request was succesful.
   */
  async removeFolder(token, removeFolderDetails) {
    const removedFolderResponse = await axiosConfigBuilder(token).post(
      '/delete_folder',
      removeFolderDetails
    );
    return removedFolderResponse.data;
  }

  /**
   * 
   * @param {string} token - User authentication token.
   * @param {Object} folderDetails - Information required to rename folder.
   * @param {string} folderDetails.newFolderName - New folder name.
   * @param {number} folderDetails.folderId - Folder ID.
   * @returns {Object} - data confirming whether request was succesful.
   */
  async renameFolder(token, folderDetails) {
    const renamedFolderResponse = await axiosConfigBuilder(token).post(
      '/rename_folder',
      folderDetails
    );
    return renamedFolderResponse.data;
  }

  /**
   * 
   * @param {string} token - User authentication token.
   * @param {Object} moveItemDetails - Information required to move items to folder.
   * @param {number} moveItemDetails.targetFolderId - Folder ID where we want to move items to.
   * @param {Object[]} moveItemDetails.items - List of folders/items we want to move.
   * @returns {Object} - data confirming whether request was succesful.
   */
  async moveToFolder(token, moveItemDetails) {
    const moveToResponse = await axiosConfigBuilder(token).post(
      '/move_to_folder',
      moveItemDetails
    );
    return moveToResponse.data;
  }
}
